// web/src/components/VerbBadge.tsx
// Reusable verb chip. Colors match the page mockup; defined as data attributes
// so consumers can override via CSS without prop drilling.

export type Verb = "scale" | "throttle" | "refresh_creative" | "kill";

const LABEL: Record<Verb, string> = {
  scale: "▲ Scale",
  throttle: "▼ Throttle",
  refresh_creative: "↻ Refresh creative",
  kill: "✕ Kill",
};

const COLOR: Record<Verb, { fg: string; bg: string }> = {
  scale:            { fg: "#5fb37a", bg: "#1f3a2a" },
  throttle:         { fg: "#d9a64a", bg: "#3a2f1f" },
  refresh_creative: { fg: "#5b9be8", bg: "#1c2c40" },
  kill:             { fg: "#d96057", bg: "#3a1f1f" },
};

export function VerbBadge({ verb }: { verb: Verb }) {
  const { fg, bg } = COLOR[verb];
  return (
    <span
      data-verb={verb}
      style={{
        display: "inline-block", padding: "2px 8px", borderRadius: 999,
        fontSize: 11, fontWeight: 600, textTransform: "uppercase",
        color: fg, background: bg,
      }}
    >
      {LABEL[verb]}
    </span>
  );
}
